export default __webpack_public_path__ + "static/media/logo.ec3c4ee4.svg";